export default "__VITE_ASSET__DwzEyxdu__"